import React, { useState } from 'react';
import { Button, Error } from 'module-tsl-ui-elements';
import { getFromContext } from '../AlertFiltersContext';
import { deleteAlert, mzTrack } from '../helpers';

export const AlertWarning = ({ message, item, action }) => {
  const { state, dispatch } = getFromContext();
  const [error, setError] = useState(false);

  const removeAlert = async () => {
    const response = await deleteAlert(state.id);
    setError(response === 'error');

    if (response === 'success') {
      dispatch({
        type: 'delete',
      });

      state.onAlertChange('Close');
    }
  };

  const onConfirm = () => {
    mzTrack('CLICK', 'dismiss-job-alert');

    if (action === 'delete') return removeAlert();

    state.onAlertChange('Close');
  };

  const onReject = () => {
    state.onAlertChange('Cancel');

    dispatch({
      type: 'cancel',
      value: item,
    });
  };

  return (
    <div className="tds-alert__warning">
      <h3>{message}</h3>
      <div className="tds-alert__warning--cta">
        <Button onClick={onConfirm}>Yes</Button>
        <Button theme="secondary" onClick={onReject}>
          No
        </Button>
      </div>
      {error && <Error classNames="tds-alert__warning__error" error="Technical issue please try again later" />}
    </div>
  );
};
